import { SaveCaseRequest } from '../types/formdataTypes';
import {
	HistoryEntryResponse,
	CasePublicResponse,
	CaseRequestStatementRequest,
	CaseResponse,
	CaseState,
	ChangeCaseStateRequest,
	FinalDecisionRequest,
	PreliminaryDecisionRequest,
	RoleDto,
	SendCaseRequest,
	StatisticResponse,
} from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'Case';

export const saveCase = async (request: SaveCaseRequest): Promise<HttpResponse<null>> => {
	const formData = new FormData();
	formData.append('caseId', request.caseId);

	if (request.title) {
		formData.append('title', request.title);
	}

	if (request.sectors) {
		formData.append('sectors', JSON.stringify(request.sectors));
	}

	if (request.mediums) {
		formData.append('mediums', JSON.stringify(request.mediums));
	}

	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}

	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}

	if (request.category) {
		formData.append('category', JSON.stringify(request.category));
	}

	if (request.reaches) {
		formData.append('reaches', JSON.stringify(request.reaches));
	}

	if (request.internalNote) {
		formData.append('internalNote', request.internalNote);
	}

	if (request.externalNote) {
		formData.append('externalNote', request.externalNote);
	}

	if (request.publishedDate) {
		formData.append('publishedDate', request.publishedDate);
	}

	const result = await makeRequest<any, null>(`${endpoint}`, formData, 'put', true);
	return result;
};

export const changeCaseState = async (request: ChangeCaseStateRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<ChangeCaseStateRequest, null>(`${endpoint}/change_state`, request, 'post');
	return result;
};

export const getCase = async (id: string): Promise<HttpResponse<CaseResponse>> => {
	const result = await makeRequest<string, CaseResponse>(`${endpoint}?caseId=${id}`, null, 'get');
	return result;
};

export const getPublicCase = async (id: string): Promise<HttpResponse<CasePublicResponse>> => {
	const result = await makeRequest<string, CasePublicResponse>(`${endpoint}/public?caseId=${id}`, null, 'get');
	return result;
};

export const getAllCases = async (): Promise<HttpResponse<CaseResponse[]>> => {
	const result = await makeRequest<string, CaseResponse[]>(`${endpoint}/all`, null, 'get');
	return result;
};

export const sendCase = async (request: SendCaseRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<SendCaseRequest, null>(`${endpoint}/send`, request, 'put');
	return result;
};

export const getCaseMedia = async (id: string): Promise<HttpResponse<string>> => {
	const result = await makeRequest<string, string>(`${endpoint}/media?caseId=${id}`, null, 'get');
	return result;
};

export const caseRequestStatement = async (request: CaseRequestStatementRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<CaseRequestStatementRequest, null>(`${endpoint}/request_statement`, request, 'put');
	return result;
};

export const getCaseNextSmallSenate = async (): Promise<HttpResponse<RoleDto>> => {
	const result = await makeRequest<string, RoleDto>(`${endpoint}/get_next_smallsenate`, null, 'get');
	return result;
};

export const casePreliminaryDecision = async (request: PreliminaryDecisionRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<PreliminaryDecisionRequest, null>(`${endpoint}/preliminary_decision`, request, 'put');
	return result;
};

export const caseFinalDecision = async (request: FinalDecisionRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<any, null>(`${endpoint}/final_decision`, request, 'post');
	return result;
};

export const publishCase = async (id: string): Promise<HttpResponse<null>> => {
	const result = await makeRequest<string, null>(`${endpoint}/publish?caseId=${id}`, null, 'post');
	return result;
};

export const unpublishCase = async (id: string): Promise<HttpResponse<null>> => {
	const result = await makeRequest<string, null>(`${endpoint}/unpublish?caseId=${id}`, null, 'post');
	return result;
};

export const getCaseLogs = async (id: string): Promise<HttpResponse<HistoryEntryResponse[]>> => {
	const result = await makeRequest<string, HistoryEntryResponse[]>(`${endpoint}/history?caseId=${id}`, null, 'get', false, false);
	return result;
};

export const deleteCaseFile = async (fileId: string): Promise<HttpResponse<null>> => {
	const result = await makeRequest<string, null>(`${endpoint}/file?fileId=${fileId}`, null, 'delete');
	return result;
};

export const deleteCaseLink = async (linkId: string): Promise<HttpResponse<null>> => {
	const result = await makeRequest<string, null>(`${endpoint}/link?linkId=${linkId}`, null, 'delete');
	return result;
};

export const getCaseStatistics = async (caseId: string): Promise<HttpResponse<StatisticResponse>> => {
	const result = await makeRequest<string, StatisticResponse>(`${endpoint}/statistics?caseId=${caseId}`, null, 'get');
	return result;
};
